import GetAgentBy_uid from "../agents/GetAgentBy_uid";
import { setLocalStorageItem } from "../localStorage/setLocalStorage";
import GetAgentId from "./GetAgentId";
import GetUserRole from "./GetUserRole";

const SeedUserRole = async (uid) => {
  /**
   * Uses user id to get business record
   * Records business id, bid in local storage
   */
  const role = await GetUserRole(uid);

  /**
   * Uses user id to get business record
   * Records business id, bid in local storage
   */
  const [aid, bid] = await GetAgentId(uid);

  /**
   * Storing user business id to local storage
   * every business data will be stored against this business id
   */
  setLocalStorageItem("role", role);

  /**
   * If authenticated user is an admin, then the
   * permissions will be set to all in localstorage
   */
  role === "admin" && setLocalStorageItem("permissions", "all");

  /**
   * If authenticated user is an agent, then the
   * permissions will be set to all in localstorage
   */
  role === "agent" &&
    setLocalStorageItem(
      "permissions",
      (await GetAgentBy_uid(aid, bid)).module_access
    );

  /**
   * If authenticated user is an agent, then the
   * permissions will be set to all in localstorage
   */
  role === "agent" && setLocalStorageItem("bid", bid);

  return role;
};

export default SeedUserRole;
